import SegmentedButton from "@/components/SegmentedButton";
import { useParams } from "@/hooks/useSearchParams";
import { COVERAGE_GROUP_BY_PARAM, type CoverageGroupBy } from "../types";
import { parseCoverageGroupBy } from "./groupCoverage";

type CoverageGroupTabsProps = {
  consultantTabLabel: string;
  onGroupByChange?: () => void;
};

export function useCoverageGroupBy(): CoverageGroupBy {
  const { params } = useParams();
  return parseCoverageGroupBy(params[COVERAGE_GROUP_BY_PARAM]);
}

export default function CoverageGroupTabs({ consultantTabLabel, onGroupByChange }: CoverageGroupTabsProps) {
  const { addSearchParam, deleteSearchParams } = useParams();
  const groupBy = useCoverageGroupBy();

  return (
    <div className="mt-6">
      <SegmentedButton
        ariaLabel="Group coverage"
        options={[
          { label: consultantTabLabel, value: "consultant" },
          { label: "By Section", value: "section" }
        ]}
        value={groupBy}
        maxButtonWidth={280}
        onChange={(selection) => {
          onGroupByChange?.();
          if (selection === "section") {
            addSearchParam(COVERAGE_GROUP_BY_PARAM, "section");
            return;
          }
          deleteSearchParams(COVERAGE_GROUP_BY_PARAM);
        }}
      />
    </div>
  );
}
